export default "__VITE_ASSET__btWkNSzD__"